<template>
  <div>
    <ul>
      <li
        v-for="(i,index) in fileList"
        :key="index"
        class="item"
        :style="{'width':itemWidth+'px','height':itemHeight+'px'}"
      >
        <el-image
          v-if="isImage(i)"
          fit="conver"
          :style="{'width':itemWidth+'px','height':itemHeight+'px'}"
          :src="i+'!size=150X150'"
        ></el-image>
        <div v-if="isVideo(i)">
          <video :id="'video_'+index" :src="i" :width="itemWidth" :height="itemHeight"></video>
        </div>
        <span class="item-actions">
          <i class="el-icon-delete" @click="itemDelete(index)"></i>
          <i v-if="type =='image' || isImage(i)" class="el-icon-zoom-in" @click="PicturePreview(i)"></i>
          <i v-if="type =='video' || isVideo(i)" class="el-icon-video-play" @click="playVideo(index)"></i>
        </span>
      </li>
      <li
        v-if="fileList.length < limit"
        class="item"
        :style="{'width':itemWidth+'px','height':itemHeight+'px'}"
        @click="dialogVisible = true"
      ><div class="empty-actions"><i class="el-icon-plus"></i></div></li>
      <!-- <li
        v-if="fileList.length < limit && type=='image'"
        class="item"
        :style="{'width':itemWidth+'px','height':itemHeight+'px'}"
        @click="dialogVisible = true"
      ><div class="empty-actions"><i class="el-icon-plus"></i></div></li>
      <li
        v-if="fileList.length < limit && type=='video'"
        class="item"
        :style="{'width':itemWidth+'px','height':itemHeight+'px'}"
        @click="dialogVisible = true"
      >
        <div class="empty-actions"><i class="el-icon-plus"></i></div>
      </li> -->
    </ul>
    <div v-if="tips" class="upload__tip">{{ tips }}</div>

    <el-button v-if="type == 'document'" style="border-radius: 0;" class="action-item" type="primary" @click="dialogVisible = true">上传文档</el-button>

    <el-dialog
      width="980px"
      :visible.sync="dialogVisible"
      append-to-body
    >
      <AttachmentSelect ref="AttachmentSelect" :limit="limit-fileList.length" :file-type="type" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="hiddenSelect">取 消</el-button>
        <el-button type="primary" @click="setSelect">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogPVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import AttachmentSelect from './AttachmentSelect'

export default {
  name: 'FileList',
  components: { AttachmentSelect },
  props: {
    value: {
      type: String,
      default: function() { return '' }
    },
    limit: { // 文件数量限制
      type: Number,
      default: 5
    },
    type: { // 默认文件类型
      type: String,
      default: 'image'
    },
    tips: { // 提示语言
      type: String,
      default: ''
    },
    itemWidth: {
      type: Number,
      default: 100
    },
    itemHeight: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      dialogPVisible: false,
      fileList: []
    }
  },
  watch: {
    value: {
      handler(val, oldVal) {
        this.fileList = val ? val.split(',') : []
      },
      immediate: true
    }
  },
  mounted() {
    console.log('123123123', this.type)
  },
  methods: {
    isImage(src) {
      return /\.(jpeg|jpg|gif|png)$/.test(src) // 检查是否为图片格式的URL或路径
    },
    isVideo(src) {
      return /\.(mp4|ogg|webm)$/.test(src) // 检查是否为视频格式的URL或路径
    },
    playVideo(index) {
      var vdo = document.getElementById('video_' + index)
      vdo.paused ? vdo.play() : vdo.pause()
    },
    PicturePreview(url) {
      this.dialogImageUrl = url
      this.dialogPVisible = true
    },
    hiddenSelect() {
      this.dialogVisible = false
      this.$refs['AttachmentSelect'].clearSelectItems()
    },
    setSelect() {
      const items = this.$refs['AttachmentSelect'].getSelectItems()
      items.forEach(element => {
        this.fileList.push(element.save_path)
      })
      this.dialogVisible = false
      this.$refs['AttachmentSelect'].clearSelectItems()
      // 修改值
      this.$emit('input', this.fileList.join(','))
    },
    itemDelete(i) {
      this.fileList.splice(i, 1)
      this.$emit('input', this.fileList.join(','))
    }
  }
}
</script>
<style lang="scss" scoped>
.item{
  border-radius: 6px;
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  display: inline-block;
  overflow: hidden;
  margin: 0 8px 8px 0;
  line-height: 100px;
  text-align: center;
  cursor: pointer;
  font-size: 28px;
  color: #8c939d;
  position: relative;
  .empty-actions{
    width: 100%;
    height: 100%;
    display: flex;
    align-items:center;
    justify-content: space-around;
  }
  .item-actions{
    width: 100%;
    height: 100%;
    display: flex;
    align-items:center;
    justify-content: space-around;
    left: 0;
    top: 0;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    transition:opacity .3s;
    -webkit-transition:opacity .3s;
    &:hover{opacity: 1;}
  }
}
.upload__tip{
    font-size: 12px;
    color: #737373;
    line-height: 20px;
}
</style>
